@if (dataLoading()) { <app-progress></app-progress> }
<div class="page-content">
    <div class="container-fluid">

        <!-- Page Title & Breadcrumb -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">{{ action().MenuTitle }}</h4>
                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item">
                                <a routerLink="/admin/admin-dashboard">Dashboard</a>
                            </li>
                            <li class="breadcrumb-item active">{{ action().ParentMenuTitle }}</li>
                            <li class="breadcrumb-item">{{ action().MenuTitle }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Card -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">

                            <div class="row mb-2">

                                <!-- New Staff Login Button -->
                                <div class="col-12 d-flex justify-content-end mb-2">
                                    @if (action().CanCreate) {
                                    <button mat-raised-button color="primary" (click)="newStaffLogin()">
                                        New Staff Login
                                    </button>
                                    }
                                </div>

                                <!-- Show Entries -->
                                <div class="col-sm-12 col-md-4">
                                    <div class="dataTables_length">
                                        <label>Show
                                            <select
                                                class="custom-select custom-select-sm form-control form-control-sm form-select form-select-sm"
                                                [(ngModel)]="itemPerPage">
                                                @for (option of PageSize; track option) {
                                                <option [value]="option">{{ option }}</option>
                                                }
                                            </select> entries
                                        </label>
                                    </div>
                                </div>

                                <!-- Search -->
                                <div class="col-sm-12 col-md-4 ms-auto">
                                    <div class="dataTables_filter d-flex justify-content-end">
                                        <label>Search:
                                            <input type="search" class="form-control form-control-sm" placeholder=""
                                                [(ngModel)]="Search">
                                        </label>
                                    </div>
                                </div>

                            </div>

                            <!-- Table -->
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="table-responsive">
                                        <table
                                            class="table table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                            role="grid">
                                            <thead>
                                                <tr role="row">
                                                    <th>S.No</th>
                                                    <th style="cursor:pointer" (click)="sort('StaffName')">Staff</th>
                                                    <th style="cursor:pointer" (click)="sort('UserName')">User Name</th>
                                                    <th>Password</th>
                                                    <th>Roles</th>
                                                    <th style="cursor:pointer" (click)="sort('Status')">Status</th>
                                                    @if (action().CanEdit || action().CanDelete) {
                                                    <th>Action</th>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (
                                                item of StaffLoginList()
                                                | filter: Search
                                                | orderBy: sortKey : reverse
                                                | paginate: { itemsPerPage: itemPerPage, currentPage: p };
                                                track item.StaffLoginId;
                                                let i = $index
                                                ) {
                                                <tr>
                                                    <td>{{ (itemPerPage * (p - 1)) + i + 1 }}</td>
                                                    <td>{{ item.StaffName }}</td>
                                                    <td>{{ item.UserName }}</td>
                                                    <td class="align-middle">
                                                        <div
                                                            class="d-inline-flex align-items-center gap-2 px-2 py-1 rounded hover-bg-light transition-all">
                                                            <code class="text-dark bg-transparent fs-6">
                                                                {{ isPasswordVisible(item.StaffLoginId) ? item.LoginPassword : '••••••••' }}
                                                                </code>
                                                            <button type="button"
                                                                class="btn btn-link btn-sm p-0 text-secondary text-decoration-none shadow-none"
                  
                                                                (click)="togglePassword(item.StaffLoginId)"
                                                                [title]="isPasswordVisible(item.StaffLoginId) ? 'Hide password' : 'Show password'">
                                                                <i class="bx fs-5 align-middle"
                                                                    [class.bx-show]="!isPasswordVisible(item.StaffLoginId)"
                                                                    [class.bx-hide]="isPasswordVisible(item.StaffLoginId)"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <ul style="margin:0;">
                                                            @for (role of item.StaffLoginRoleList; track role.RoleId) {
                                                            <li>{{ role.RoleTitle }}</li>
                                                            }
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <span class="p-1"
                                                            [ngClass]="item.Status == 1 ? 'badge text-bg-success' : 'badge text-bg-danger'">
                                                            {{ AllStatusList[item.Status] }}
                                                        </span>
                                                    </td>
                                                    @if (action().CanEdit || action().CanDelete) {
                                                    <td>
                                                        @if (action().CanEdit) {
                                                        <a class="text-success p-1" style="cursor:pointer"
                                                            (click)="editStaffLogin(item)">
                                                            <i class="bx bxs-edit-alt"></i>
                                                        </a>
                                                        }
                                                        @if (action().CanDelete) {
                                                        <a class="text-danger p-1" style="cursor:pointer"
                                                            (click)="deleteStaffLogin(item)">
                                                            <i class="bx bxs-trash"></i>
                                                        </a>
                                                        }
                                                    </td>
                                                    }
                                                </tr>
                                                }
                                                @if (StaffLoginList().length === 0 && !dataLoading()) {
                                                <tr>
                                                    <td colspan="6" class="text-center text-muted">
                                                        No staff logins found
                                                    </td>
                                                </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Pagination -->
                                <div>
                                    <pagination-controls (pageChange)="onTableDataChange($event)" style="float:right;"
                                        class="my-pagination">
                                    </pagination-controls>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Modal -->
@if (showModal() && (action().CanEdit || action().CanCreate)) {
<div class="modal fade show d-block" tabindex="-1" style="background:rgba(0,0,0,0.5)">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">

            <div class="modal-header">
                <h1 class="modal-title fs-5">
                    {{ StaffLogin.StaffLoginId > 0 ? 'Update' : 'New' }} Staff Login
                </h1>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>

            <div class="modal-body">
                <div class="container">

                    <form #formStaffLogin="ngForm">
                        <div class="row">
                            <mat-form-field appearance="outline" class="col-sm-3">
                                <mat-label>Staff</mat-label>
                                <input matInput #StaffName="ngModel" name="StaffName" [(ngModel)]="StaffLogin.StaffName"
                                    (ngModelChange)="filterStaffList($event)" [matAutocomplete]="autoStaffName" required
                                    autofocus>
                                <mat-autocomplete #autoStaffName="matAutocomplete">
                                    @for (option of filterStaff(); track option.StaffId) {
                                    <mat-option [value]="option.StaffName"
                                        (onSelectionChange)="StaffLogin.StaffId = option.StaffId">
                                        {{ option.StaffName }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                                @if ((StaffName.dirty || StaffName.touched) || (StaffName.invalid && isSubmitted)) {
                                <mat-error>Staff Name is <strong>required</strong></mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="col-sm-3">
                                <mat-label>Username</mat-label>
                                <input matInput #UserName="ngModel" name="UserName" [(ngModel)]="StaffLogin.UserName"
                                    required>
                                @if ((UserName.dirty || UserName.touched) || (UserName.invalid && isSubmitted)) {
                                <mat-error>User Name is <strong>required</strong></mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="col-sm-3">
                                <mat-label>Login Password</mat-label>
                                <input [type]="hide ? 'password' : 'text'" matInput #LoginPassword="ngModel"
                                    name="LoginPassword" [(ngModel)]="StaffLogin.LoginPassword" required>
                                <button mat-icon-button matSuffix type="button" (click)="hide = !hide">
                                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                                @if ((LoginPassword.dirty || LoginPassword.touched) || (LoginPassword.invalid &&
                                isSubmitted)) {
                                <mat-error>Login Password is <strong>required</strong></mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="col-sm-3">
                                <mat-label>Status</mat-label>
                                <mat-select #Status="ngModel" name="Status" [(ngModel)]="StaffLogin.Status" required>
                                    @for (status of StatusList; track status.Key) {
                                    <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                                    }
                                </mat-select>
                                @if ((Status.dirty || Status.touched) || (Status.invalid && isSubmitted)) {
                                <mat-error>Status is <strong>required</strong></mat-error>
                                }
                            </mat-form-field>

                        </div>
                    </form>

                    <!-- Staff Roles -->
                    <div class="row mt-3">
                        <div class="col-12">
                            <h3 class="header-text">Staff Roles</h3>
                            <hr style="border:2px solid rgb(19, 25, 97);">
                        </div>
                        @for (role of StaffLoginRoleList(); track role.RoleId) {
                        <div class="col-6 col-sm-2">
                            <input [id]="'id' + role.RoleId" [ngModel]="role.IsSelected"
                                (ngModelChange)="role.IsSelected = $event" [name]="'role' + role.RoleId"
                                class="form-check-input me-2" type="checkbox">
                            <label [for]="'id' + role.RoleId" class="form-check-label text-link">
                                {{ role.RoleTitle }}
                            </label>
                        </div>
                        }
                    </div>

                </div>
            </div>

            <div class="modal-footer mt-4">
                <button type="button" mat-raised-button color="warn" class="me-2" (click)="closeModal()">Cancel</button>
                <button mat-raised-button color="primary" (click)="saveStaffLogin()">
                    {{ StaffLogin.StaffLoginId > 0 ? 'Update' : 'Submit' }}
                </button>
            </div>

        </div>
    </div>
</div>
}